module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/192-philippines-348441ed76fa13ac98a94f892ff74a60.svg";